import React from 'react'
import PropTypes from 'prop-types'
import { KeyTableHead } from '../components/Table/data'
import BodyContainer from '../components/bodyContainer'

const Keys = ({
  keys,
  fetchData,
  isLoadingkeysList,
  pageLimitChanged,
  pageChanged,
  success,
  onCloseReset,
  keysCount,
  searchKeys,
  errorMessage,
  removeError,
  isErrorFetch,
  isSuccessRefresh,
  resetSuccessAction,
}) => {
  return (
    <BodyContainer
      //EtatdisplayMode
      isDisplayMode={false}
      //TableMode
      actionButton={true}
      tableHead={KeyTableHead}
      //Commonfields
      globalID={'Key'}
      searchPlaceholder={'Rechercher par clé'}
      title={'Configuration des clés'}
      fetchData={fetchData}
      loadingData={isLoadingkeysList}
      dataList={keys}
      countData={keysCount}
      errorMessage={errorMessage}
      removeError={removeError}
      removeErrorConfig={() => {}}
      isErrorFetch={isErrorFetch}
      pageLimitChanged={pageLimitChanged}
      pageChanged={pageChanged}
      searchData={searchKeys}
      onCloseReset={onCloseReset}
      resetSuccessAction={resetSuccessAction}
      success={success}
      isSuccessRefresh={isSuccessRefresh}
      isKey={true}
    />
  )
}
Keys.propTypes = {
  keys: PropTypes.array,
  fetchData: PropTypes.func,
  isLoadingkeysList: PropTypes.bool,
  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  searchKeys: PropTypes.func,
  keysCount: PropTypes.number,
  success: PropTypes.bool,
  onCloseReset: PropTypes.func,
  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,
}
export default Keys
